import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';

/**
 * The persistent app chrome: one Sidebar (and the right-edge rail it carries) mounted above the
 * routed pages instead of inside each of them.
 *
 * Every page used to render its own <Sidebar/>, so any navigation across page components tore the
 * whole rail down and rebuilt it — the hierarchy scrolled back to the top and the tree's reveal
 * effects re-ran, reopening branches that had just been collapsed. Navigating between /kb-review
 * and /activity was the accidental exception (one component, two routes, so React kept the
 * instance), which made the resets look random rather than structural.
 *
 * The sidebar is `fixed` and pages offset themselves with pl-[var(--sidebar-w)], so nothing about
 * page layout changes by mounting it here. Login, the docs and the admin area stay outside this
 * shell deliberately — they never carried the sidebar.
 */
export function AppShell() {
  return (
    <>
      <Sidebar />
      <Outlet />
    </>
  );
}
